import React, {useContext, useState} from 'react'
import {checkRole} from '../../../_metronic/helpers'
import FeatureGate from '../../components/FeatureGate'
import {FEATURE_KEYS} from '../../features/featureRegistry'
import {RoleContextValue} from '../../types/OtherTypes'
import roleContext from '../../context/roleContext'
import {Link} from 'react-router-dom'
import {clsx} from '@mantine/core'
import LeavePolicy from '../leave-policy/LeavePolicy'
import LeaveTypes from '../leave-types/LeaveTypes'

const LeaveSetting = () => {
  let roleState: RoleContextValue = useContext(roleContext)
  //Leave Policy & Leave Type alos show to admin
  const isAdmin = roleState.roleName?.toLowerCase() === 'admin'
  // const [activeTab, setActiveTab] = useState(
  //   checkRole(['leave_types'], roleState.features) ? 'leave-types' : 'leave-policy'
  // )
  const [activeTab, setActiveTab] = useState(
    isAdmin || checkRole([FEATURE_KEYS.settings_leave_type], roleState.features)
      ? 'leave-types'
      : 'leave-policy'
  )
  const handleTabClick = (tab) => {
    setActiveTab(tab)
  }
  

  return (
    <>
      <div>
        <div
          // id='kt_toolbar_container'
          className={clsx('d-flex justify-content-between card ps-5 mb-4')}
        >
          <div className='d-flex h-55px'>
            <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap'>
              {/* Leave Config removed - all settings via Leave Policy */}
              {/* <FeatureGate feature={FEATURE_KEYS.settings_leave_type}> */}
              {/* Leave Types */}
              {(isAdmin || checkRole([FEATURE_KEYS.settings_leave_type], roleState.features)) && (
                <li className='nav-item'>
                  <Link
                    className={clsx('nav-link text-active-primary me-4', {
                      active: activeTab === 'leave-types',
                    })}
                    to=''
                    onClick={() => handleTabClick('leave-types')}
                  >
                    Leave Types
                  </Link>
                </li>
              )}
               {/* </FeatureGate> */}
              {/* <FeatureGate feature={FEATURE_KEYS.settings_leave_policy}> */}
              {(isAdmin || checkRole([FEATURE_KEYS.settings_leave_policy], roleState.features)) && (
                <li className='nav-item'>
                  <Link
                    className={clsx('nav-link text-active-primary me-4', {
                      active: activeTab === 'leave-policy',
                    })}
                    to=''
                    onClick={() => handleTabClick('leave-policy')}
                  >
                    Leave Policy
                  </Link>
                </li>
              )}
              {/* </FeatureGate> */}
            </ul>
          </div>
        </div>
      </div>
      <div className='row justify-content-center'>
        {activeTab === 'leave-types' ? (
          <LeaveTypes />
        ) : activeTab === 'leave-policy' ? (
          <div className='col-12 mt-4'>
            <LeavePolicy />
          </div>
        ) : null}
      </div>
    </>
  )
}

export default LeaveSetting
